/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs } from '@mui/material';
import { VIEW_TAB_MATRIX, VIEW_TAB_MALHA } from './constants';

const VIEW_TABS = [
  { id: VIEW_TAB_MATRIX, label: 'Matriz Cliente' },
  { id: VIEW_TAB_MALHA, label: 'Operacional por Malha' },
];

const ViewTabs = ({ value, onChange, disabled }) => (
  <Tabs
    value={value}
    onChange={(_, next) => onChange(next)}
    variant="scrollable"
    scrollButtons="auto"
    sx={{ borderBottom: 1, borderColor: 'divider' }}
  >
    {VIEW_TABS.map((tab) => (
      <Tab
        key={tab.id}
        value={tab.id}
        label={tab.label}
        disabled={disabled}
        sx={{ textTransform: 'none', fontWeight: 600, minHeight: 44 }}
      />
    ))}
  </Tabs>
);

ViewTabs.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ViewTabs.defaultProps = {
  disabled: false,
};

export default ViewTabs;
